import { useEffect, useState } from 'react';

export type Breakpoint = 'sm' | 'md' | 'lg' | 'xl';

const ORDER: Breakpoint[] = ['sm', 'md', 'lg', 'xl'];

const QUERIES: Record<Exclude<Breakpoint, 'sm'>, string> = {
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
};

function compute(): Breakpoint {
  if (typeof window === 'undefined') return 'xl';
  if (window.matchMedia(QUERIES.xl).matches) return 'xl';
  if (window.matchMedia(QUERIES.lg).matches) return 'lg';
  if (window.matchMedia(QUERIES.md).matches) return 'md';
  return 'sm';
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(compute);

  useEffect(() => {
    const mqls = (Object.keys(QUERIES) as (keyof typeof QUERIES)[]).map((k) =>
      window.matchMedia(QUERIES[k]),
    );
    const handler = () => setBp(compute());
    mqls.forEach((m) => m.addEventListener('change', handler));
    handler();
    return () => mqls.forEach((m) => m.removeEventListener('change', handler));
  }, []);

  return bp;
}

export function useIsAtLeast(target: Breakpoint): boolean {
  const bp = useBreakpoint();
  return ORDER.indexOf(bp) >= ORDER.indexOf(target);
}
